import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IMineGrammarPointV1Request } from './mine-grammar-point-v1-request';
import type { IMineGrammarPointV1Response } from './mine-grammar-point-v1-response';
import { mineGrammarPointV1ResponseSchema } from './mine-grammar-point-v1-response';

export async function mineGrammarPointV1Api(
  pointId: number,
  params: IMineGrammarPointV1Request = {},
  options?: IRequestOptions,
): Promise<IValidatedResponse<IMineGrammarPointV1Response>> {
  const query = params.cursor === undefined ? '' : `?cursor=${params.cursor}`;
  return postRequest<IMineGrammarPointV1Response>({
    path: `/sys/grammar/v1/points/${pointId}/mine${query}`,
    schema: mineGrammarPointV1ResponseSchema,
    options,
  });
}
